<template>
<v-list dense full-width >
  <template v-for='action in filteredActions' >
    <v-divider
      v-if='action.type === "divider"'
      :key='action.id' />
    <template v-else >
      <v-list-tile
        :key='action.id'
        v-if="exclude.indexOf(action.id) === -1"
        :disabled='action.disableIf && action.disableIf(appointment)'
          @close='visible=false'
          @click='itemAction(action)'  >
          <v-list-tile-avatar>
              <v-icon>{{action.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{action.title}}</v-list-tile-title>
          </v-list-tile-content>
          <template v-if='action.extraActions' >
            <v-list-tile-action
              v-for='extra in action.extraActions(appointment)'
              :key='extra.icon' >
              <v-btn outline outlined icon small
                @click.stop='extra.action(appointment)' >
                <v-icon v-if='extra.icon' small >{{extra.icon}}</v-icon>
                <!-- <span class="hidden-xs-only" v-if='extra.text'>{{extra.text}}</span> -->
              </v-btn>
            </v-list-tile-action>
          </template>
      </v-list-tile>
    </template>
  </template>
</v-list>
</template>
<script>
import AppointmentMixins from '@/mixins/appointments'
export default {
  name: 'ActionList',
  mixins: [AppointmentMixins],
  props: {
    appointment: { type: Object, default: () => { return {} } },
    exclude: { type: Array, default: () => { return [] } }
  },
  methods: {
    itemAction (action) {
      action.onclick()
      this.$ga.event('appointment', action.title + ' clicked')
    }
  },
  computed: {
    spaceIds () {
      if (this.appointment) {
        return [this.appointment.space]
      }
      return []
    },
    isSpaceOwner () {
      if (this.appointment && this.appointment.status === 'B') { return true }
      if (this.appointment && this.appointment.space) {
        let spaceId = this.appointment.space
        if (this.$store.getters.lookups && this.$store.getters.lookups.spaces && spaceId in this.$store.getters.lookups.spaces) {
          return this.$store.getters.lookups.spaces[spaceId].role === 'Owner'
        }
      }
      return false
    },
    isOwner () {
      return parseInt(this.appointment.practitioner) === parseInt(this.meId)
    },
    filteredActions () {
      if (this.appointmentActions) {
        if (this.isOwner) { return this.appointmentActions }
        return this.appointmentActions.filter((action) => {
          if (action.type === 'divider') { return action }
          if (this.isSpaceOwner && action.ownerCan) { return action }
          if (action.id === 'show_client') { return action }
          if (this.hasPermission(action.id, [this.appointment.space], [this.appointment])) {
            return action
          }
        })
      }
      return []
    }
  }
}
</script>



// WEBPACK FOOTER //
// ActionList.vue?20bf19b2